import { cn } from "../../lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn("animate-pulse rounded-sm bg-hover-strong motion-reduce:animate-none", className)}
      {...props}
    />
  );
}

export { Skeleton };
